import api from "../utils/api";

export const createSection = async (section_name) => {
  try {
    const response = await api.post("/section", section_name);
    return response.data;
  } catch (error) {
    throw error;
  }
}

export const getSection = async (section_id) => {
  try {
    const response = await api.get(`/section/${section_id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
}

export const getAllSections = async () => {
  try {
    const response = await api.get("/section");
    return response.data;
  } catch (error) {
    throw error;
  }
}

export const updateSection = async (section_id, updated_section_name) => {
  try {
    const response = await api.put(`/section/${section_id}`, updated_section_name);
    return response.data;
  } catch (error) {
    throw error;
  }
}

export const deleteSection = async (section_id) => {
  try {
    const response = await api.delete(`/section/${section_id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
}
